<section class="lg:flex md:sm:grid md:sm:grid-cols-1 items-center gap-4">
    @if (!embedded) {
    <a [href]="setupUrl">
      <img [src]="images.arrowLeft" class="h-6 w-6 mr-2.5 cursor-pointer" />
    </a>
    }
    <article class="lg:flex rounded h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" [width]="'60'" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    <article class="relative lg:flex rounded h-10" (click)="filterOpened = !filterOpened">
      <button id="buttonOpenFilter"
        class="search-bar-button text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center gap-2"
        [ngClass]="{ 'opened' : filterOpened || filtersApplied > 0, 'filtersApplied': filtersApplied > 0 }">
        <img [src]="images.filter" alt="filter" class="w-6 h-6" [ngClass]="{ 'filter-primary-purple-light': filterOpened }" />
        <span class="font-semibold text-base">{{ literalService.get("bookings.filter", true) }}</span>
        @if (filtersApplied > 0) {
          <span class="font-bold text-primary-purple-light text-[14px]">
            ({{ filtersApplied }})
          </span>
        }
      </button>
    </article>
    <article class="flex absolute mt-118.75 w-max max-w-[calc(100vw-8rem)] z-10" [ngClass]="{ 'hidden': !filterOpened }">
      <app-filter-panel [componentOpen]="'buttonOpenFilter'"
        [fields]="filterFields"
        [filterType]="filterTypes.AVAILABILITIES"
        [selection]="panelSelection"
        (filter)="applyFilter($event)"
        (closeFilter)="filterOpened = false"
      />
    </article>
    <article class="relative lg:flex rounded h-10">
      <button id="buttonRowsDisplayOpen"
        class="search-bar-button text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : rowsDisplayOpened, 'filtersApplied': rowsDisplayValue !== defaultRowsDisplay }" (click)="rowsDisplayOpened = !rowsDisplayOpened">
        <img [src]="images.visibility" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened filter-primary-purple-light': rowsDisplayOpened || rowsDisplayValue !== defaultRowsDisplay }" />
        <span class="font-semibold text-base">{{ `${literalService.get("bookings.show", true)}: ${rowsDisplayValue}` }}</span>
      </button>
      <article class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !rowsDisplayOpened }">
        <app-rows-display [componentOpen]="'buttonRowsDisplayOpen'" [value]="rowsDisplayValue" (close)="rowsDisplayOpened = false" (onChange)="updateNumberOfElements($event)"></app-rows-display>
      </article>
    </article>
    @if (searching) {
      <article class="flex items-center">
        <img [src]="images.loading" alt="loading" class="h-8 w-8 ml-4" />
        <label class="font-semibold text-base ml-4">{{ literalService.get('availabilities.searchingAvailabilities', true) }}...</label>
      </article>
    }
    <section class="flex ml-auto gap-4 items-center">
      @if (allowBulkEditing) {
        <article class="flex flex-row gap-4 items-center">
          @if (bulkSelectedAction === '') {
            <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onCreateDepartures.emit()" [tooltip]="literalService.get('availabilities.actions.createDepartures.title', true)">
              <img [src]="images.setup.addAvailabilities" alt="createDepartures" class="w-6 h-6" />
            </article>
          }
          @for (action of bulkActions; track $index) {
            @if ((bulkSelectedAction !== '' && bulkSelectedAction === action.action) || (bulkSelectedAction === '') ) {
              @if (showActionButton(action.action)) {
                <article class="px-4 py-1 rounded-[44px] cursor-pointer bg-primary-purple-light text-neutrals-white" (click)="onBulkAction.emit()">
                  {{ literalService.get(action.label, true) }}
                </article>
              }
              <article class="w-10 h-10 flex justify-center items-center rounded-full outlinedButton" [ngClass]="{ 'bg-primary-purple-light-2 selected': bulkSelectedAction === action.action, 'cursor-pointer': bulkSelectedAction === '' }" (click)="onActionChange(action.action)" [tooltip]="literalService.get(action.label, true)" [visibleTooltip]="bulkSelectedAction === ''">
                <img [src]="action.image" [alt]="action.action" class="w-6 h-6" [ngClass]="{ 'selected': bulkSelectedAction === action.action }" />
              </article>
            }
          }
        </article>
      }
      @if (bulkSelectedAction !== '') {
        <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onActionChange('')">
          <img [src]="images.close" alt="cancelBulk" class="w-6 h-6" />
        </article>
      }
    </section>
  </section>
  